import { render, staticRenderFns } from "./WaybillCreateRX.vue?vue&type=template&id=ab4009e2&"
import script from "./WaybillCreateRX.vue?vue&type=script&lang=js&"
export * from "./WaybillCreateRX.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports